import SelectorDocumentsContainer from 'components/SelectorDocuments/SelectorDocumentsContainer'

export default {
  Container: SelectorDocumentsContainer,
}
